import React, { Component } from 'react';
import './footer.css';

class Footer extends Component {
  render() {
    return (
		<footer className="main-footer">
			<small>&copy; {(new Date().getFullYear())} <a href="https://visualize.news/" target="_read" rel="noopener">Visualize News</a> - Designed and developed by <a href="http://www.makinguse.com/" target="_read" rel="noopener">Carlo Zapponi</a>, <a href="https://simonelippolis.com/" target="_read" rel="noopener">Simone Lippolis</a> - <a href="#/leggi/privacy">Informativa sulla privacy e termini del servizio</a> - <a href="https://github.com/leeppolis/elezioni-io-data" rel="noopener">Data Source</a>.</small>
		</footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Elezioni/footer.js